import * as Yup from "yup";

export const ValidationSchema = Yup.object({
  name: Yup.string().required("Business Name is required!"),
  category_id: Yup.string().required("Business Category is required!"),
  subcategory_id: Yup.string().required("Business Subcategory is required!"),
  owner_name: Yup.string().required("Business Owner Name is required!"),
  address: Yup.string().required("Business Address is required!"),
  phone_number: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile Number must be 10 digits long and contain only numbers")
    .required("Mobile Number is required!"),
  wp_number: Yup.string()
    .matches(/^[0-9]{10}$/, "WhatsApp Number must be 10 digits long and contain only numbers")
    .required("WhatsApp Number is required!"),
  email: Yup.string().email("Invalid email format!").required("Email is required!"),
  // business_link: Yup.string().required("Business Link is required!"),
  // facebook_link: Yup.string().required("Facebook Link is required!"),
  // instagram_link: Yup.string().required("Instagram Link is required!"),
  // youTube_link: Yup.string().required("YouTube Link is required!"),
  // linkedIn_link: Yup.string().required("LinkedIn Link is required!"),
  logo: Yup.string().nullable(),
  member_id: Yup.string().required("Member is required!"),
  is_active: Yup.string().required("Status is required!"),
});
